import { Card } from '@/components/ui/card'
import { StatsCardBaseProps, StatsCardBase } from './StatsCardBase'
import { ReactNode } from 'react'
import { InfoTooltip } from '@/components/ui/info-tooltip'

interface StatsCardDesktopProps extends StatsCardBaseProps {
  chart?: ReactNode
}

/**
 * Desktop version of StatsCard
 * Uses base logic but has desktop-specific UI with chart support
 */
export const StatsCardDesktop = ({
  icon,
  iconAlt,
  label,
  helpText,
  value,
  loading = false,
  chart,
  className = ''
}: StatsCardDesktopProps) => {
  const displayValue = StatsCardBase.getDisplayValue(value, loading)
  const iconNode = typeof icon === 'string'
    ? <img src={icon} alt={iconAlt} className="w-4 h-4 dark:[filter:brightness(0)_invert(1)_opacity(0.72)]" />
    : <span className="inline-flex h-4 w-4 items-center justify-center text-[rgba(45,41,35,0.72)] dark:text-[rgba(253,253,253,0.72)]">{icon}</span>

  return (
    <Card variant="default" padding="none" className={`rounded-none shadow-none bg-white dark:bg-[#1c1c1c] border border-solid border-white dark:border-[#1c1c1c] relative h-[124px] pt-3 pb-3 pl-6 pr-7 ${className}`}>
      {/* Left side - Icon, Label, Value — z-10 so chart (sibling, later in DOM) does not capture clicks on the info control */}
      <div className="absolute left-6 top-6 z-10 flex flex-col justify-between h-[76px]">
        <div className="flex items-center gap-1.5">
          {iconNode}
          <span 
            className="font-plus-jakarta font-medium text-[13px] leading-[18px] text-[rgba(45,41,35,0.72)] dark:text-[rgba(253,253,253,0.72)]"
            style={{fontFeatureSettings: '"liga" off, "clig" off'}}
          >
            {label}
          </span>
          {helpText ? <InfoTooltip content={helpText} ariaLabel={`${label} info`} /> : null}
        </div>
        <span className="text-[28px] leading-[32px] text-[#2d2923] dark:text-[#fdfdfd] tracking-[-0.2px] font-medium" >
          {displayValue}
        </span>
      </div>
      
      {/* Right side - Chart (optional, desktop only) */}
      {chart && (
        <div className="absolute right-7 top-3 w-full max-w-[214px] h-[100px]">
          {chart}
        </div>
      )}
    </Card>
  )
}
